import { PAPERLESS_TOGGLE_TEXT_DICT } from './constants';
import { INTL_IDS } from './messages';

export const getFormPaperlessSettings = (currentPaperlessSettings) =>
  Object.keys(currentPaperlessSettings).reduce((acc, hashedLoanNumber) => {
    const { status } = currentPaperlessSettings[hashedLoanNumber];
    acc[hashedLoanNumber] = { status };
    return acc;
  }, {});

export const getMultiLoanPaperlessDetails = (currentSettingValues, formatMessage) => {
  const num = currentSettingValues.reduce(
    (acc, { status }) => status.slice(0, 6) === 'Enable' ? acc + 1 : acc, 0,
  );
  if (num) {
    return formatMessage({ id: INTL_IDS.HOME_PAPERLESSBILLING_DETAILS }, { num });
  }
  return 'Off';
};

export const getPaperlessFormProps = (currentSettings, formSettings) => {
  const { allowedOperation, status: currentStatus } = currentSettings;
  const { status: formStatus } = formSettings;
  return {
    isButtonDisabled: currentStatus === formStatus,
    isToggleDisabled: !['Request_Disable', 'Request_Enable'].includes(allowedOperation),
    isToggleOn: formStatus.slice(0, 6) === 'Enable',
    toggleText: PAPERLESS_TOGGLE_TEXT_DICT[formStatus],
  };
};

export const isAlertSettingsMatch =
  (arr1, arr2) => arr1.every((val, i) => JSON.stringify(val) === JSON.stringify(arr2[i]));
